import { useQuery } from 'react-query'
import { APPID, GET_IDEA, GET_ITEMS, GET_ME2, GET_OTHER_USER, GET_USER_INSPIRATION, GET_USER_INSPIRATIONS } from '../constants/ApiEndpoints'
import { getUserToken } from '../utils/fetchUtils'
import { requestHelper } from '../utils/reduxActionUtils'

export const getPrerenderedUserInfo = async userId => {
  const result = await fetch(GET_OTHER_USER, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Parse-Application-Id': APPID
    },
    body: JSON.stringify({
      userId
    })
  })

  if (!result.ok) {
    throw new Error('Data fetching failed')
  }

  return await result.json()
}

export const getPrerenderedUserInfoByUniqueDisplayName = async uniqueDisplayName => {
  const result = await fetch(GET_OTHER_USER, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Parse-Application-Id': APPID
    },
    body: JSON.stringify({
      uniqueDisplayName
    })
  })

  if (!result.ok) {
    throw new Error('Data fetching failed')
  }

  return await result.json()
}

export const getPrerenderedPost = async postId => {
  const result = await fetch(GET_USER_INSPIRATION, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Parse-Application-Id': APPID
    },
    body: JSON.stringify({
      objectId: postId
    })
  })

  if (!result.ok) {
    throw new Error('Data fetching failed')
  }

  return await result.json()
}

export const getPrerenderedUserDesigns = async (userId, limit = 12) => {
  const result = await fetch(GET_USER_INSPIRATIONS, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Parse-Application-Id': APPID
    },
    body: JSON.stringify({
      userId,
      limit,
      skip: 0
    })
  })

  if (!result.ok) {
    throw new Error('Data fetching failed')
  }

  return await result.json()
}

export const getPrerenderedItemsByIds = async itemIds => {
  if (!itemIds || itemIds.length === 0) return { items: [] }

  const result = await fetch(GET_ITEMS, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Parse-Application-Id': APPID
    },
    body: JSON.stringify({
      itemIds
    })
  })

  if (!result.ok) {
    throw new Error('Data fetching failed')
  }

  return await result.json()
}

export const getPrerenderedItemsByIdeaId = async objectId => {
  if (!objectId) return { idea: { productsWithPosition: [] } }

  const result = await fetch(GET_IDEA, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Parse-Application-Id': APPID
    },
    body: JSON.stringify({
      objectId
    })
  })

  if (!result.ok) {
    throw new Error('Data fetching failed')
  }

  return await result.json()
}

export const useUserInfo = query => {
  return useQuery(
    ['GET_USER_INFO'],
    async () => {
      if (!getUserToken()) return {}
      //console.log("HOLY SHIT, THS GETS CALLED JUST TO CHECK ON NOTIFICATIONS")
      const params = requestHelper()
      const res = await fetch(GET_ME2, params)
      const { result } = await res.json()
      return result
    },
    {
      refetchInterval: 30000, //10 * 1000,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchIntervalInBackground: 60 * 1000
    }
  )
}
